import { Eye, EyeOff } from 'lucide-react';

interface LessonStatusIndicatorProps {
  published: boolean;
}

export const LessonStatusIndicator = ({ published }: LessonStatusIndicatorProps) => {
  return published ? (
    <div className="flex items-center gap-1 text-green-600">
      <Eye className="h-4 w-4" /> 
      <span className="text-xs md:text-sm">Publicado</span>
    </div>
  ) : (
    <div className="flex items-center gap-1 text-gray-500">
      <EyeOff className="h-4 w-4" /> 
      <span className="text-xs md:text-sm">No publicado</span>
    </div>
  );
};